<template>
  <div class="location-breadcrumb" v-if="locationHierarchy">
    <!-- Main Breadcrumb -->
    <div class="breadcrumb-container">
      <span v-if="locationHierarchy.state">
        <a :href="`/search-properties/state/${locationHierarchy.state.id}`" class="breadcrumb-link">
          {{ locationHierarchy.state.name }}
        </a>
        <span class="separator">/</span>
      </span>

      <span v-if="locationHierarchy.county">
        <a :href="`/search-properties?state=${locationHierarchy.state?.id}&county=${encodeURIComponent(locationHierarchy.county.name)}`"
           class="breadcrumb-link">
          {{ locationHierarchy.county.name }}
        </a>
        <span class="separator">/</span>
      </span>

      <span v-if="locationHierarchy.city">
        <a :href="`/search-properties/city/${encodeURIComponent(locationHierarchy.city.name)}/${locationHierarchy.state?.id}`"
           class="breadcrumb-link">
          {{ locationHierarchy.city.name }}
        </a>
        <span v-if="locationHierarchy.neighborhood" class="separator">/</span>
      </span>

      <span v-if="locationHierarchy.neighborhood" class="current-location">
        {{ locationHierarchy.neighborhood.name }}
      </span>
    </div>

    <!-- Campus affiliation (subtle, below breadcrumb) -->
    <div v-if="locationHierarchy.campuses && locationHierarchy.campuses.length > 0"
         class="campus-info">
      <span class="campus-label">Near:&nbsp;</span>
      <span v-for="(campus, index) in visibleCampuses" :key="campus.id">
        <a :href="getCampusUrl(campus)" class="campus-link">
          {{ campus.school ? campus.school.name : campus.name }}
        </a>
        <span v-if="index < visibleCampuses.length - 1">, </span>
      </span>
      <button
        v-if="locationHierarchy.campuses.length > 3"
        @click="toggleCampuses"
        class="campus-toggle"
      >
        {{ showAllCampuses ? 'Show less' : `+${locationHierarchy.campuses.length - 3} more` }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationBreadcrumb',
  props: {
    locationHierarchy: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showAllCampuses: false
    }
  },
  computed: {
    visibleCampuses() {
      if (!this.locationHierarchy?.campuses) return [];
      if (this.showAllCampuses) return this.locationHierarchy.campuses;
      return this.locationHierarchy.campuses.slice(0, 3);
    }
  },
  methods: {
    getCampusUrl(campus) {
      // Pattern: /search-properties/campus/{id}/{slug}
      let url = `/search-properties/campus/${campus.id}`;
      if (campus.slug) {
        url += `/${campus.slug}`;
      }
      return url;
    },
    toggleCampuses() {
      this.showAllCampuses = !this.showAllCampuses;
    }
  }
}
</script>

<style scoped>
.location-breadcrumb {
  margin-bottom: 8px;
  font-size: 15px;
  line-height: 1.5;
}

.breadcrumb-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #333;
}

.breadcrumb-link {
  color: #1976d2;
  text-decoration: none;
  transition: color 0.15s ease;
}

.breadcrumb-link:hover {
  color: #1565c0;
  text-decoration: underline;
}

.separator {
  color: #999;
  margin: 0 8px;
  user-select: none;
}

.current-location {
  color: #333;
}

.campus-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
  font-size: 13px;
  color: #666;
}

.campus-label {
  color: #666;
}

.campus-link {
  color: #1976d2;
  text-decoration: none;
  transition: color 0.15s ease;
}

.campus-link:hover {
  color: #1565c0;
  text-decoration: underline;
}

.campus-toggle {
  background: none;
  border: none;
  color: #1976d2;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  transition: color 0.15s ease;
}

.campus-toggle:hover {
  color: #1565c0;
  text-decoration: underline;
}
</style>
